export interface ISolarAccountViewServiceAddress {
  serviceAddressId: number;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
  zipPlus4: string;
  isCertified: boolean;
  county: string;
  country: string;
  deliveryPointCheckDigit: string;
  locationType: string;
  timeZone: string;
  latitude: number;
  longitude: number;
  effectiveDate: Date;
}

export class SolarAccountViewServiceAddress
  implements ISolarAccountViewServiceAddress {
  serviceAddressId: number;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
  zipPlus4: string;
  isCertified: boolean;
  county: string;
  country: string;
  deliveryPointCheckDigit: string;
  locationType: string;
  timeZone: string;
  latitude: number;
  longitude: number;
  effectiveDate: Date;
}
